import React, { useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import APIList from "../../utils/constants/APIList";
import { postDetails } from "../../services/http/http.service";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { Group } from "../../utils/constants/Interfaces.constants";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import convertTimestamp from "../../utils/helpers/convertTimeStamp";
import formatDate from "../../utils/helpers/formatDate";

const GroupTable = ({
  isGroupDataFetched,
}: {
  isGroupDataFetched: boolean;
}) => {
  const cmpMounted = useRef(false);
  const [group, setGroup] = useState<Group[]>([]);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // if (cmpMounted.current === true) return;
    // cmpMounted.current = true;
    fetchGroup();
  }, [isGroupDataFetched]);

  const fetchGroup = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_ALL_GROUP, {});
      const modifiedData = response.data.map((item: Group) => ({
        ...item,
        created: new Date(item.created).toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }));
      setGroup(modifiedData);
    } catch (error) {
      console.log("Error Fetching Groups", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const columns: TableColumn[] = [
    { key: "name", label: "Group Name", sortable: true, dataType: "string"},
    {
      key: "employees_count",
      label: "Employee Count",
      sortable: true,
      dataType: "string",
      // search: true
    },
    {
      key: "created",
      label: "Created On",
      dataType: "string",
        // search:true,
      sortable: true,
    },
    { key: "status", label: "Status", dataType: "toggle", sortable: true},
  ];

  const deleteItemById = async (item: Group) => {
    const response = await postDetails(APIList.DELETE_GROUP, { id: item.id });
    if (response.status === "Failed") {
      // alert("Cannot delete group")
      dispatch(showToast("Cannot delete group"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    dispatch(showToast("Group Deleted Successfully."));
    setTimeout(() => dispatch(hideToast()), 3000);

    fetchGroup();
  };

  const toggleStatus = async (item: Group) => {
    const response = await postDetails(APIList.TOGGLE_GROUP_STATUS, {
      id: item.id,
      status: item.status === 0 ? 1 : 0,
    });
    if (response.status === "Failed") {
      // alert("Cannot change group status")
      dispatch(showToast("Cannot change group status"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    dispatch(showToast("Status Updated Successfully."));
    setTimeout(() => dispatch(hideToast()), 3000);

    setGroup((prevData) =>
      prevData.map((row: Group) =>
        row.id === item.id ? { ...row, status: row.status === 0 ? 1 : 0 } : row
      )
    );

    fetchGroup();
  };

  const handleEdit = (item: any) => {
    navigate(`/group/edit`, { state: { isEdit: true, data: item } });
  };

  return (
    <div>
      <CommonTable<Group>
        data={group}
        columns={columns}
        onEdit={handleEdit}
        onDelete={deleteItemById}
        onToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: false,
          status: false,
        }}
      />
    </div>
  );
};

export default GroupTable;
